"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MeldType_1 = require("../../meld/MeldType");
/**
 * Determine if the WinningHand is an AllKongs (Chinese: 十八羅漢).
 * @param inputWinningHand WinningHand to be evaluated.
 * @returns true if the inputWinningHand is an AllKongs (Chinese: 十八羅漢).
 */
function isAllKongs(inputWinningHand) {
    const melds = inputWinningHand.getMelds();
    for (const meld of melds) {
        if (meld.getMeldType() === MeldType_1.MeldType.EYES)
            continue;
        if (meld.getMeldType() !== MeldType_1.MeldType.KONG) {
            return false;
        }
    }
    return true;
}
exports.default = isAllKongs;
